const OPEN_CLASS = 'is--open';
const languageButtons = document.querySelectorAll('.js-language-selector');

for (const button of languageButtons) {
	button?.addEventListener('click', toggleDropDown);
}

function toggleDropDown(event) {
	event.preventDefault();
	event.target
		.closest('.js-language-selector')
		.parentElement.classList.toggle(OPEN_CLASS);
}
